export const QUERY_KEYS = {
    ACCOUNT: "account",
    SESSION: "session",
    CURRENT: "current",
    ASSETS_USD_CONVERSION: "assetsUsdConversion",
};
//# sourceMappingURL=constants.js.map